import {loadable} from 'router/routes';
import {Page} from 'router/page';
import {fetchCity, foldWithSearchState} from './utils';
import React from 'react';

const SearchMobile = loadable(() => import('search/SearchMobile'));
const SearchDesktop = loadable(() => import('search/SearchDesktop'));

// eslint-disable-next-line react/prop-types
const City = ({configData: {isMobile}}) =>
    isMobile ? <SearchMobile /> : <SearchDesktop />;

City.getInitialState = async ({state, params, query, cookies}) => {
    const city = await fetchCity(state, params.city);

    const {
        data: {latitude, longitude, timezone},
    } = city;

    return foldWithSearchState({
        state: {...state, city},
        type: Page.CITY,
        latitude,
        longitude,
        timezone,
        query,
        cookies,
    });
};

export default City;
